/* eslint-disable react/no-danger */
/* eslint-disable multiline-ternary */
/* eslint-disable @typescript-eslint/no-floating-promises */

"use client";

import { JSX, Suspense, useEffect } from "react";
import { initAckoAnalytics } from "@acko-tech/building-blocks.ui.acko-analytics";
import { getTrackerId } from "./user-utils";
import { getEnvConfig } from "@config/env-based-config";
import { TENANT_TYPE } from "@enums/tenant";
import { useEnvVariablesClientConfig } from "@contexts/env-variables-context";
import Script from "next/script";

export const InitialiseAckoAnalyticsImpl = ({
  tenant = TENANT_TYPE.ACKOSEO,
}) => {
  const config = useEnvVariablesClientConfig();
  const currentEnv = config?.ACKO_ENV || "";

  const SEGMENT_WRITE_KEY = getEnvConfig(currentEnv)?.segmentKey?.[tenant];
  const trackerIdVal = getTrackerId();
  return (
    <div>
      {currentEnv && trackerIdVal && SEGMENT_WRITE_KEY ? (
        <Script
          async
          id="my-script"
          type="text/javascript"
          dangerouslySetInnerHTML={{
            __html: initAckoAnalytics(
              trackerIdVal || "",
              SEGMENT_WRITE_KEY || ""
            ),
          }}
        />
      ) : null}
    </div>
  );
};

export const InitialiseAckoAnalytics = (
  props: JSX.IntrinsicAttributes & { tenant?: TENANT_TYPE | undefined }
) => (
  <Suspense>
    <InitialiseAckoAnalyticsImpl {...props} />
  </Suspense>
);
